import { render, staticRenderFns } from "./enquiryDetail.vue?vue&type=template&id=28bbeedf&scoped=true"
import script from "./enquiryDetail.vue?vue&type=script&lang=js"
export * from "./enquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./enquiryDetail.vue?vue&type=style&index=0&id=28bbeedf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bbeedf",
  null
  
)

export default component.exports